import { InsuranceAgentInternalService } from "../services/insuranceAgentInternalService";
import { InsuranceAgentBaseStore } from "./insuranceAgentBaseStore";
import { GlobalStore } from "@roc/feature-app-core";

export class InsuranceAgentInternalStore extends InsuranceAgentBaseStore {
  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.insuranceAgentService = new InsuranceAgentInternalService();
  }
}